import React, {useEffect} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment-timezone';
import { startLoadingClienteSaldos } from '../../../actions/clientesaldos';

const TIPO_MOVIMIENTO_PENALIZACION = 'penalizacion';

export const conceptoMovimientoCita = (clienteSaldo) => {
  if (clienteSaldo.tipo === TIPO_MOVIMIENTO_PENALIZACION) return 'Penalización Reserva';
  if (clienteSaldo.monto < 0) return 'Reserva';
  return 'Cancelación Reserva';
};

export const ClienteSaldos = ({objCliente, saveCliente}) => {

  const dispatch = useDispatch();

  const { empresa } = useSelector(state => state.auth);
  const { colores } = useSelector(state => state.ui);
  const { clienteSaldos } = useSelector(state=>state.clienteSaldos);

  useEffect(() => {
    console.log("Listado clienteSaldos...", saveCliente);
    dispatch(startLoadingClienteSaldos(objCliente._id));
  }, [saveCliente, objCliente._id]);
  
  return (
    <div className='cliente-saldos'>
        {
            clienteSaldos &&
            [...clienteSaldos].sort((a, b) => new Date(b.fecha) - new Date(a.fecha)).map( (clienteSaldo, idx) => (
                <div 
                    key={ idx }
                    className='cliente-saldos-row'
                    style={{ backgroundColor: colores.color6 }}
                >
                    <div className='cliente-saldos-date'>
                        <p><b>{ moment( clienteSaldo?.fecha ).format('D/M/YY') }</b> { moment( clienteSaldo?.fecha ).format('H:mm') }h</p>
                    </div>
                    <div className='cliente-saldos-text'>
                        <p style={{ 
                            color: clienteSaldo.monto >= 0 ? '#28a745' : '#dc3545',
                            fontWeight: 'bold'
                        }}>
                            {clienteSaldo.monto >= 0 ? '+' : ''}{clienteSaldo.monto}€
                        </p>
                    </div>
                    {clienteSaldo.updatedbyadmin && 
                        <div className='cliente-saldos-text' style={{ textAlign: 'center' }}>
                            <p>Modificado por Admin</p>
                        </div>
                    }
                    {clienteSaldo.cita && 
                        <>
                            <div className='cliente-saldos-text' style={{ textAlign: 'center' }}>
                                <p>{ conceptoMovimientoCita(clienteSaldo) }</p>
                            </div>
                            <div className='cliente-saldos-date'>
                                <p><b>{ moment( clienteSaldo.cita.fecha ).format('D/M/YY') }</b> { moment( clienteSaldo.cita.fecha ).format('H:mm') }h</p>
                            </div>
                            <div className='cliente-saldos-text'>
                                <p>{ clienteSaldo.cita.sucursal.nombre}</p>
                            </div>
                        </>
                    }
                </div>
            ))
        }
    </div>
  )
}

